var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "question" },
    [
      _c("resource-classify", {
        attrs: {
          courseId: _vm.courseId,
          subjectId: _vm.subjectId,
          from: "question"
        },
        on: { changeFunc: _vm.changeFunc }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "handle" },
        [
          _c("div", { staticClass: "btns_area" }, [
            _c(
              "div",
              {
                staticClass: "custom-btn custom-full-btn",
                on: {
                  click: function($event) {
                    return _vm.addBtn()
                  }
                }
              },
              [_vm._v("添加试题")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "custom-btn custom-empty-btn",
                on: {
                  click: function($event) {
                    return _vm.deleteBtn()
                  }
                }
              },
              [_vm._v("\n        批量删除\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("n-search-input", { on: { searchInput: _vm.searchFunc } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("n-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            attrs: {
              tableData: _vm.tableData,
              tableHeader: _vm.QuestionTableHeader,
              ISChangeCheckout: true,
              TableHeight: _vm.TableHeight
            },
            on: { operation: _vm.operation }
          }),
          _vm._v(" "),
          _c("Pagination", {
            attrs: {
              currentpage: _vm.pageTotal.currentPage,
              limit: _vm.pageTotal.pageSize,
              total: _vm.pageTotal.total,
              layout: "total, sizes, prev, pager, next, jumper",
              small: true
            },
            on: {
              handleCurrentChange: _vm.handleCurrentChange,
              handleSizeChange: _vm.handleSizeChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("n-dialog", {
        attrs: {
          title: _vm.dialogTitle,
          dialogVisible: _vm.addQuestionShow,
          width: _vm.dialogWidth,
          courseId: _vm.courseId,
          subjectId: _vm.subjectId,
          questionId: _vm.questionId,
          dialogType: _vm.dialogType,
          deleteNum: _vm.deleteNum,
          deleteName: _vm.deleteName
        },
        on: { closeDialog: _vm.closeDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c85d166", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c85d166","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_course_module/editCourse/question/index.vue
// module id = null
// module chunks = 